// Overgezet uit naslag/server/imports/api/staticGameData/tasks.ts en
// naslag/server/server/generateData/tasks.ts (de volgorde van `addTasks`).
import { TaskType } from '../types/tasks.js';
import { kloon } from '../hulp.js';
import { AssetDataTaken } from './taken/AssetData.js';
import { IncidentTaken } from './taken/Incident.js';
import { MagazijnTaken } from './taken/Magazijn.js';
import { OBSTaken } from './taken/OBS.js';
import { OnderhoudsTaken } from './taken/Onderhoud.js';
import { OrganisatieTaken, TOPMONTEUR_NIVEAU, topmonteurTaak } from './taken/Organisatie.js';
import { ProductieTaken } from './taken/Productie.js';
import { RevisieTaken } from './taken/Revisie.js';
import { StoringsTaken } from './taken/Storing.js';
import { VeiligheidsTaken } from './taken/Veiligheid.js';
export { AssetDataTaken, IncidentTaken, MagazijnTaken, OBSTaken, OnderhoudsTaken, OrganisatieTaken, ProductieTaken, RevisieTaken, StoringsTaken, VeiligheidsTaken, TOPMONTEUR_NIVEAU, topmonteurTaak, };
export const skipRoundTask = {
    _id: '_skipRound',
    type: TaskType.internalMiscellaneous,
    title: 'Skip een ronde',
    description: 'De spelers hebben gekozen om geen taken te spelen. Verwerk deze ronde als normaal.',
    cost: 0,
    inGameEffect: [],
    inGameEffectDescription: '',
    needsSparepart: false,
    needsMechanic: false,
};
export const skipPlayerTask = {
    _id: '_skipPlayer',
    type: TaskType.internalMiscellaneous,
    title: 'Geen taak gekozen',
    description: 'Een speler heeft geen taak gekozen.',
    cost: 0,
    inGameEffect: [],
    inGameEffectDescription: '',
    needsSparepart: false,
    needsMechanic: false,
};
/**
 * Wat de `transform` van `TasksCollection` deed bij elke `find`: de oude velden
 * `inGameEffect` en `inGameEffectDescription` afleiden uit `taskEffects`, of andersom
 * `taskEffects` maken uit de oude velden. In het origineel stond erbij: "TODO dit
 * weghalen (is allemaal compatibility dingen)". De schermen lezen beide vormen, dus hij
 * blijft.
 */
function transformeer(doc) {
    const task = { ...doc };
    if (task.taskEffects) {
        task.inGameEffect = task.taskEffects.map((t) => t.type);
        task.inGameEffectDescription = task.taskEffects[0]?.description ?? '';
    }
    else {
        task.taskEffects = task.inGameEffect.map((e) => {
            return {
                type: e,
                description: task.inGameEffectDescription,
                asset: task.specificAsset,
            };
        });
    }
    return task;
}
/**
 * Alle taken zoals ze in de collectie `staticGameData.tasks` stonden: in de volgorde
 * van `addTasks` en zonder de transform. Niet aanpassen; gebruik `getAllTasks` voor een
 * eigen kopie.
 */
export const TAKEN = [
    ...VeiligheidsTaken,
    ...OrganisatieTaken,
    ...OnderhoudsTaken,
    ...MagazijnTaken,
    ...StoringsTaken,
    ...IncidentTaken,
    ...OBSTaken,
    ...AssetDataTaken,
    ...ProductieTaken,
    ...RevisieTaken,
];
/**
 * Niet in het origineel: kaarten die niet in een stapel zitten en alleen bij een
 * gebeurtenis in een hand komen. `getTask` en `getSpecificTaskData` vinden ze wel,
 * `getAllTasks` (waaruit de stapels komen) niet.
 */
export const LOSSE_TAKEN = [topmonteurTaak];
const ALLE_KAARTEN = [...TAKEN, ...LOSSE_TAKEN];
/**
 * Zoals `TasksCollection.find({}).fetch()`: elke taak getransformeerd en als nieuwe kopie,
 * zodat wie het resultaat aanpast de statische data niet raakt (Mongo gaf ook steeds
 * nieuwe objecten).
 */
export const getAllTasks = () => TAKEN.map((t) => transformeer(kloon(t)));
/**
 * Zoals het origineel: de gevraagde taken in de volgorde van de collectie (niet die van
 * `tasksToRetrieve`), zonder dubbele en zonder de interne overslaan-taken. Alleen
 * `['_skipRound']` geeft `[skipRoundTask]` terug.
 */
export function getSpecificTaskData(tasksToRetrieve) {
    if (tasksToRetrieve.length === 1 && tasksToRetrieve[0] === skipRoundTask._id)
        return [skipRoundTask];
    const ids = tasksToRetrieve.filter((id) => ![skipRoundTask._id, skipPlayerTask._id].includes(id));
    return ALLE_KAARTEN.filter((t) => ids.includes(t._id)).map((t) => transformeer(kloon(t)));
}
/** Eén taak op id, zoals `TasksCollection.findOne(id)`; getransformeerd en als kopie. */
export function getTask(taskId) {
    const task = ALLE_KAARTEN.find((t) => t._id === taskId);
    return task ? transformeer(kloon(task)) : undefined;
}
